import styled from 'styled-components';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import { variables } from '../../assets/styles/variables';

const TradingSideBarContainer = styled.div`
  margin-bottom: ${pxToRem(20)};
  display: flex;
  flex-direction: ${({ bpMd }) => (bpMd ? 'row' : 'column')};
  ${(props) => props.css};

  ${mediaBelow(variables.breakpoints.bpXl)} {
    padding: 0 ${pxToRemMd(16)};
  }
  ${mediaBelow(variables.breakpoints.bpMd)} {
    padding: 0 ${pxToRemMd(16)};
  }
`;

export default TradingSideBarContainer;
